export const maxStafferContractVersionSupported = 5; // By This App Version
export const maxBusinessContractVersionSupported = 2; // By This App Version